// extracted by mini-css-extract-plugin
export default {"Loader-wrapper":"loader_Loader-wrapper__gMOuS","loader":"loader_loader__tt2US","Table":"loader_Table__nsajt"};